import { DEFAULT_AUDIO_PREFS } from './audio';
/**
 * Тонка обгортка над localStorage. Зберігає прогрес кампанії і налаштування
 * звуку. Винесено окремо, щоб модулі ігри не залежали від глобального
 * `localStorage` (зручно для тестів і SSR).
 */
const KEY = 'bbm:save';
const DEFAULT_SETTINGS = { audio: { ...DEFAULT_AUDIO_PREFS } };
const DEFAULT = {
    version: 2,
    unlockedLevel: 1,
    highScore: 0,
    fastestRunMs: null,
    settings: DEFAULT_SETTINGS,
};
export function loadSave() {
    try {
        if (typeof localStorage === 'undefined')
            return cloneDefault();
        const raw = localStorage.getItem(KEY);
        if (!raw)
            return cloneDefault();
        const parsed = JSON.parse(raw);
        if (!parsed)
            return cloneDefault();
        // міграція з v1: settings там не було
        const settings = parsed.settings && parsed.settings.audio
            ? { audio: {
                    enabled: !!parsed.settings.audio.enabled,
                    volume: clamp01(parsed.settings.audio.volume ?? DEFAULT_AUDIO_PREFS.volume),
                } }
            : { audio: { ...DEFAULT_AUDIO_PREFS } };
        return {
            version: 2,
            unlockedLevel: clampInt(parsed.unlockedLevel ?? 1, 1, 999),
            highScore: Math.max(0, parsed.highScore ?? 0),
            fastestRunMs: parsed.fastestRunMs ?? null,
            settings,
        };
    }
    catch {
        return cloneDefault();
    }
}
export function saveSave(s) {
    try {
        if (typeof localStorage === 'undefined')
            return;
        localStorage.setItem(KEY, JSON.stringify(s));
    }
    catch { /* приватний режим тощо */ }
}
export function resetSave() {
    try {
        localStorage?.removeItem(KEY);
    }
    catch { /* */ }
}
function cloneDefault() {
    return {
        ...DEFAULT,
        settings: { audio: { ...DEFAULT_AUDIO_PREFS } },
    };
}
function clampInt(n, lo, hi) {
    return Math.max(lo, Math.min(hi, n | 0));
}
function clamp01(n) {
    return Math.max(0, Math.min(1, +n || 0));
}
